import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address } from 'src/app/admin-api/model/address';
import { ResponseB4AAddress } from 'src/app/admin-api/model/responseB4AAddress';
import { environment } from 'src/environments/environment';
import { StorageService } from './auth/storage.service';
import {
  PersonAddressUpdateRequest,
  personAddressUpdateUrl,
  unwrapUpdatedAddress
} from './person-address.util';

/**
 * Temporary client until OpenAPI regen includes PUT /address/{personId}/{addressId}.
 * A single request is sent. Failures are not retried.
 */
@Injectable({ providedIn: 'root' })
export class PersonAddressService {
  private http = inject(HttpClient);

  update(
    personId: number,
    addressId: number,
    body: PersonAddressUpdateRequest
  ): Observable<Address> {
    return this.http
      .put<
        ResponseB4AAddress | Address
      >(personAddressUpdateUrl(environment.apiUrl, personId, addressId), body, { headers: this.authHeaders() })
      .pipe(map((response) => unwrapUpdatedAddress(response)));
  }

  private authHeaders(): HttpHeaders {
    let headers = new HttpHeaders({ Accept: 'application/json' });
    if (StorageService.userLogged && StorageService.token) {
      headers = headers.set('Authorization', `Bearer ${StorageService.token}`);
    }
    return headers;
  }
}
